import moment from 'moment';
import pkg from '../../package.json';

interface BuildInfo {
  date: string;
  version: string;
  git: string;
  env: string;
  deployer: string;
  criticalRelease: boolean;
}

export async function getBuildInfo(): Promise<BuildInfo | undefined> {
  try {
    const buildInfo = await fetch(`/buildInfo.json?d=${Date.now()}`);
    return await buildInfo.json();
  } catch (error) {
    console.error(error);
  }
}

export function getVersionString() {
  const { version } = pkg;
  const buildDate = moment(new Date(__BUILD_TIME__ * 1000)).format('YYYY-MM-DD');
  return `v${version} (${buildDate})`;
}
